var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96935 1.22704C3.82874 1.36768 3.74976 1.55841 3.74976 1.75729C3.74976 1.95616 3.82874 2.14689 3.96935 2.28754L7.68185 6.00004L3.96935 9.71254C3.83273 9.85399 3.75713 10.0434 3.75884 10.2401C3.76055 10.4367 3.83943 10.6248 3.97848 10.7639C4.11754 10.903 4.30565 10.9818 4.5023 10.9835C4.69894 10.9853 4.8884 10.9097 5.02985 10.773L9.2726 6.53029C9.4132 6.38964 9.49219 6.19891 9.49219 6.00004C9.49219 5.80116 9.4132 5.61043 9.2726 5.46979L5.02985 1.22704C4.8892 1.08643 4.69847 1.00745 4.4996 1.00745C4.30072 1.00745 4.10999 1.08643 3.96935 1.22704Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.f748b1b9cdece83a968ad80265e37bbd.svg";
export { ForwardRef as ReactComponent };